import { FarmContext } from '@context/FarmContext';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useContext, useState } from 'react';
import { FiCheck, FiChevronDown } from 'react-icons/fi';
import { GiFarmTractor } from 'react-icons/gi';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import {
  ChevronIcon,
  DropdownContent,
  DropdownItem,
  DropdownLabel,
  DropdownTrigger,
  EmptyState,
  FarmIcon,
  FarmInfo,
  FarmLabel,
  FarmName,
  ItemContent,
  ItemIcon,
  ItemName,
  PlaceholderText,
  SelectedIndicator,
  TriggerContent,
} from './styles';

export function SelectFarm() {
  const { farm, farms, selectFarm } = useContext(FarmContext);
  const [isOpen, setIsOpen] = useState(false);

  const selectedFarm = farms?.find((f) => f.id === farm);

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownTrigger>
        <TriggerContent>
          <FarmIcon>
            <GiFarmTractor />
          </FarmIcon>
          <FarmInfo>
            <FarmLabel>Fazenda</FarmLabel>
            {selectedFarm ? <FarmName title={selectedFarm.name}>{selectedFarm.name}</FarmName> : <PlaceholderText>Selecione...</PlaceholderText>}
          </FarmInfo>
        </TriggerContent>
        <ChevronIcon $isOpen={isOpen}>
          <FiChevronDown />
        </ChevronIcon>
      </DropdownTrigger>

      <DropdownMenu.Portal>
        <DropdownContent align="end" sideOffset={8}>
          <DropdownLabel>Suas Fazendas</DropdownLabel>

          {farms && farms.length > 0 ? (
            farms.map((farmItem) => {
              const isSelected = farmItem.id === farm;
              return (
                <DropdownItem key={farmItem.id} $isSelected={isSelected} onSelect={() => { selectFarm(farmItem.id); }}>
                  <ItemIcon $isSelected={isSelected}>
                    <HiOutlineOfficeBuilding />
                  </ItemIcon>
                  <ItemContent>
                    <ItemName>{farmItem.name}</ItemName>
                  </ItemContent>
                  {isSelected && (
                    <SelectedIndicator>
                      <FiCheck />
                    </SelectedIndicator>
                  )}
                </DropdownItem>
              );
            })
          ) : (
            <EmptyState>
              <HiOutlineOfficeBuilding />
              <span>Nenhuma fazenda encontrada</span>
            </EmptyState>
          )}
        </DropdownContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
